<template>
  <div class="component-coupon-table" v-if="tableThData[couponType]">
    <Table
      :tableThData="tableThData[couponType]"
      :tableTrData="tableTrData"
      :pagination="false"
    >
      <template #couponTemplateId="{ row }">{{ row.couponTemplateId || '---' }}</template>
      <template #thirdId="{ row }">{{ row.thirdId || '---' }}</template>
      <template #productName="{ row }">{{ row.productName || '---' }}</template>
      <template #typeName="{ row }">{{ row.typeName || '---' }}</template>
      <template #officialPrice="{ row }">{{ row.officialPrice || '---' }}</template>
      <template #price="{ row }">{{ row.price || '---' }}</template>
      <template #stock="{ row }">{{row.stock ? row.stock : (row.stock === 0? row.stock : '---')}}</template>

      <template #id="{ row }">{{ row.id }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #type="{ row }">{{ onCouponeType(row.type)}}</template>
      <template #detail="{ row }">{{ row.detail }}</template>
      <template #require="{ row }">{{ row.require }}</template>
      <template #threshold="{ row }">{{ row.threshold }}</template>
      <template #discountInfo="{ row }">{{ row.discountInfo }}</template>
      <template #remain="{ row }">{{ row.remain }}</template>
      <template #stores="{ row }">
        <el-button v-if="row.stores" type="text" @click="onLookStore(row)">查看使用范围</el-button>
        <span v-else>---</span>
      </template>
      <template #useTime="{ row }">{{ row.useTime }}</template>
      <template #subTitle="{ row }">{{ row.subTitle }}</template>
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #discount="{ row }">{{ row.discount }}</template>
      <template #validTime="{ row }">{{ row.validTime }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
      <template #description="{ row }">
        <el-tooltip placement="right" effect="light">
          <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">{{ row.description }}</div>
          <div style="white-space: pre-wrap; width: 200px;" slot="content">{{ row.description }}</div>
        </el-tooltip>
      </template>

      <template #templateCode="{ row }">{{ row.templateCode || '---' }}</template>
      <template #suitObject="{ row }">{{ row.suitObject == 'sku' ? '内部商品' : '店铺' }}</template>
      <template #supplier="{ row }">{{ row.supplier=="VoucherCenter"?"券中台投放":"闰土自制" }}</template>
      <template #totalStock="{ row }">{{ row.totalStock || '---' }}</template>
      <template #issueType="{ row }">{{ issueTypeMap[row.issueType] || '---' }}</template>
      <template #totalStockStr="{ row }">{{ row.totalStockStr ? row.totalStockStr : '---' }}</template>
      <template #issuedStock="{ row }">{{ row.issuedStock ? row.issuedStock : '---' }}</template>
    </Table>

  </div>
</template>

<script>
import Table from "@/components/Table/index";

export default {
  name: "component-coupon-table",
  components: {
    Table,
  },
  props: {
    couponType: {
      type: String,
      default() {
        return ''
      }
    },
    tableTrData: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      isShowStoreDialog:false,
      currentRow:[],
      issueTypeMap: {
        'Auto': '自动发放',
        'Stock': '库存发放',
      },
      tableThData: {
        'vcWelfareCoupon': [
          { prop: "couponTemplateId", label: "ID", minWidth: "120", },
          { prop: "thirdId", label: "券编号", minWidth: "120", },
          { prop: "productName", label: "券名称", minWidth: "180", },
          { prop: "typeName", label: "品牌名称", minWidth: "180", },
          { prop: "price", label: "成本价", minWidth: "120", },
          { prop: "officialPrice", label: "官方价", minWidth: "120", },
          { prop: "stock", label: "库存", minWidth: "120", },
        ],
        'vcRecharge': [
          { prop: "couponTemplateId", label: "ID", minWidth: "120", },
          { prop: "thirdId", label: "券编号", minWidth: "120", },
          { prop: "productName", label: "券名称", minWidth: "180", },
          { prop: "typeName", label: "品牌名称", minWidth: "180", },
          { prop: "price", label: "成本价", minWidth: "120", },
          { prop: "officialPrice", label: "官方价", minWidth: "120", },
          { prop: "stock", label: "库存", minWidth: "120", },
        ],
        'CouponCenter': [
          { prop: "id", label: "ID", minWidth: "120", },
          { prop: "name", label: "优惠券名称", minWidth: "200", },
          { prop: "type", label: "优惠券类型", minWidth: "120", },
          { prop: "discountInfo", label: "券优惠", minWidth: "120", },
          { prop: "threshold", label: "券门槛", minWidth: "180", },
          { prop: "validTime", label: "用券时间", minWidth: "280", },
          { prop: "remain", label: "可投放数量", minWidth: "280", },
        ],
        'Coupon': [
          { prop: "id", label: "ID", minWidth: "60", },
          { prop: "name", label: "优惠券名称", minWidth: "200", },
          { prop: "type", label: "优惠券类型", minWidth: "90", },
          { prop: "detail", label: "券优惠", minWidth: "120", },
          { prop: "require", label: "券门槛", minWidth: "180", },
          { prop: "useTime", label: "用券时间", minWidth: "280", },
        ],
        'GiftCoupon': [
          { prop: "id", label: "ID", minWidth: "60", },
          { prop: "name", label: "礼品券名称", minWidth: "120", },
          { prop: "subTitle", label: "标题", minWidth: "120", },
          { prop: "useTime", label: "券有效时间", minWidth: "100", },
          { prop: "useRangeType", label: "核销范围", minWidth: "80", },
        ],
        'LotCoupon': [
          { prop: "id", label: "ID", minWidth: "60", },
          { prop: "mallName", label: "商场名称", minWidth: "120", },
          { prop: "name", label: "停车券名称", minWidth: "200", },
          { prop: "discount", label: "抵扣优惠", minWidth: "110", },
          { prop: "validTime", label: "券有效时间", minWidth: "160", },
        ],
        'SkuCoupon': [
          { prop: "id", label: "ID", minWidth: "60", },
          { prop: "templateCode", label: "券模板编码", minWidth: "100", },
          { prop: "name", label: "抵扣券名称", minWidth: "180", },
          { prop: "type", label: "抵扣券类型", minWidth: "100", },
          { prop: "suitObject", label: "适用对象", minWidth: "80", },
          { prop: "detail", label: "抵扣金额", minWidth: "160", },
          { prop: "require", label: "使用门槛", minWidth: "120", },
          { prop: "useTime", label: "用券时间", minWidth: "260", },
          { prop: "useRangeType", label: "使用范围", minWidth: "80", },
          { prop: "totalStockStr", label: "总库存", minWidth: "80", },
          { prop: "supplier", label: "来源", minWidth: "80", },
          { prop: "issueType", label: "发放类型", minWidth: "80", },
        ],
      },
    };
  },
  created() {
    console.log(this.tableTrData)
  },
  methods: {
    onCouponeType(type){
     if(this.couponType == 'CouponCenter'){
       switch (type) {
        case 'CashCoupon':
          return '代金劵'
        case 'PercentOff':
          return '折扣券'
        default:
          return '---'
      }
     } else {
        return type
     }
    },
    onLookStore(row) {
      this.currentRow = row.stores
      this.isShowStoreDialog = true
    },
  },
};
</script>

<style lang="scss" scoped>
.component-coupon-table {

  .table-box {
    margin-top: 0;
  }
  .storeDialog{
    width: 100%;
    height: 300px;
    text-align: center;
    overflow-y: auto;
  }
}
</style>
